import { HttpClient } from '@angular/common/http';
import {Translation, TRANSLOCO_CONFIG, TRANSLOCO_LOADER, translocoConfig, TranslocoLoader, TranslocoModule} from '@ngneat/transloco';
import {Injectable, NgModule} from '@angular/core';
import {locals} from "./common";
import {Lib} from "../libs/Lib";
import {retryWithBackoff} from "../libs/rxjs/retryWithBackoff";

@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader {

    constructor(private http: HttpClient) {
    }

    getTranslation(lang: string) {
        const url = `./assets/i18n/${lang}.json?${Math.random()}`;
        return this.http.get<Translation>(url)
            .pipe(retryWithBackoff(url, null, null));
    }
}

@NgModule({
    exports: [TranslocoModule],
    providers: [
        {
            provide: TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs: locals,
                fallbackLang: 'en',
                defaultLang: 'en',
                // Remove this option if your application doesn't support changing language in runtime.
                reRenderOnLangChange: true,
                missingHandler: {
                    useFallbackTranslation: true,
                    logMissingKey: false
                },
                prodMode: !Lib.DevMode(),
            })
        },
        {provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader}
    ]
})
export class TranslocoRootModule {
}
